var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"large-text-section",style:(_vm.styles)},[_c('div',{staticClass:"grid grid--container"},[_c('VText',{staticClass:"large-text-section__text"},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }